<template>
  <div>
    <div v-if="listingreferrals && listingreferrals.length" class="ut-overflow-auto">
      <table class="md:ut-w-full ut-mx-0 ut-text-sm ut-text-left listing-referral-table">
        <listing-referral-table-head />
        <listing-referral-table-body :listingreferrals="listingreferrals" />
      </table>
    </div>
    <div v-else class="ut-py-6 ut-text-sm ut-text-neutral-400 ut-italic">
      There are no listing referrals in the selected date range.
    </div>
  </div>
</template>

<script>
import ListingReferralTableHead from '@/components/ListingReferrals/ListingReferralTableHead';
import ListingReferralTableBody from '@/components/ListingReferrals/ListingReferralTableBody';

export default {
  name: 'ListingReferralTable',
  components: {
    ListingReferralTableHead,
    ListingReferralTableBody,
  },
  props: {
    listingreferrals: { required: true },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.address {
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .listing-referral-table {
    width: 700px;
  }
}
</style>
